const renderDataRow = ({data, label, format = (point) => point}) =>
  !!data && data !== '-' ? `<div>${label}: ${format(data) || '-'}</div>` : '';

export default renderDataRow;
